// CORE
import React from 'react';
import { useSelector } from 'react-redux';

// USER DEFINED
import Routes from "Routes/Route";
import Sidebar  from "./Commons/Sidebar/Sidebar";
import Header  from "./Commons/Header/Header";

//STYLES
import { RightContentWrapper, ContentWrapper, LayoutStyled } from "./Website.style";

function Website(props){
    const isAdminLoggedIn = useSelector(state => state.Auth.isAdminLoggedIn);
	return(
		<React.Fragment>
			<LayoutStyled>
                {
                    isAdminLoggedIn ?
                    <LoggedInComponents />
                    :
                    <Routes />
                }
            </LayoutStyled>
		</React.Fragment>
	)
}

function LoggedInComponents(props) {
    return (
        <>
            <Sidebar />
            <RightContentWrapper isAdminLoggedIn={true}>
                <Header />
                <ContentWrapper isAdminLoggedIn={true}>
                    <Routes />
                </ContentWrapper>

            </RightContentWrapper>
        </>
    )
}

export default Website;